// Keep failures independent: an unavailable CRM section must not hide the others.
export function selectContextDeal(deals, selectedId, conversationDealId) {
  if (selectedId === 'contact') return null
  return deals.find(deal => deal.id === selectedId)?.id
    || deals.find(deal => deal.id === conversationDealId)?.id
    || deals.find(deal => deal.status === 'aberto')?.id
    || deals[0]?.id || null
}

export async function loadContactContext(contactId, readers) {
  const empty = { contact: null, deals: [], activities: [], history: [], errors: {} }
  if (!contactId) return empty
  const keys = ['contact', 'deals', 'activities', 'history']
  const results = await Promise.allSettled(keys.map(key => Promise.resolve().then(() => readers[key](contactId))))
  return results.reduce((context, result, index) => {
    const key = keys[index]
    if (result.status === 'rejected') context.errors[key] = true
    else context[key] = key === 'contact' ? result.value || null : Array.isArray(result.value) ? result.value : []
    return context
  }, empty)
}
